const getSearchableText = (value: string): string => value.toLocaleLowerCase();

export const includesSearch = (value: string, searchValue: string): boolean =>
  getSearchableText(value).includes(getSearchableText(searchValue));
